"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEnrollmentPayload = void 0;
/** Splits a single display name into first/last (last name absorbs any extra words). */
const splitCustomerName = (name) => {
    const [firstName = '', ...rest] = name.trim().split(/\s+/).filter(Boolean);
    return { firstName, lastName: rest.join(' ') };
};
/**
 * Maps a customer onto the Growth enrollment contract, or `null` when the contract
 * cannot be satisfied: it needs both name parts and at least one way to reach them.
 */
const buildEnrollmentPayload = (customer) => {
    var _a;
    const { firstName, lastName } = splitCustomerName((_a = customer.name) !== null && _a !== void 0 ? _a : '');
    const { email, phone, address } = customer;
    if (!firstName || !lastName || (!email && !phone)) {
        return null;
    }
    return Object.assign({ firstName,
        lastName,
        email, phoneNumber: phone }, (address ? { address } : {}));
};
exports.buildEnrollmentPayload = buildEnrollmentPayload;
//# sourceMappingURL=enrollment.js.map